<template >
  <v-flex xs12 md6 lg4 xl3 px-2 mb-2 class="on-white-background">
    <v-hover>
     <v-card
        class="px-4 py-2 mb-2 rounded-3 elevation-2 cardBackground"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 3 : 0}`">
        <router-link class="no-link-style" :to="{ name: 'Email', params: {email_id: email.id} }">
          <v-card-title class="pa-0 pb-2 pt-1">
            <v-flex xs12>
              <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">{{email.name}}</h3>
            </v-flex>
            <v-flex xs12 pr-4>
              <h4 class="text-truncate">
                <span class="primary--text body-1 opacity-54 pt-1">Email Template</span>
              </h4>
            </v-flex>
          </v-card-title>
        </router-link>
        <v-card-actions class="card-vert-menu">
            <v-menu
              left offset-y nudge-top="30px"
              origin="center center" transition="scale-transition">
              <v-btn
                flat icon dark small
                slot="activator" class="ma-0 mr-0 pa-0" color="secondary"
                style="margin-top:-3px !important; margin-left:-10px !important;"
                @click.prevent>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list dense>
                  <v-list-tile @click="deleteDialog = true">
                  <v-icon class="mr-2" color="error">remove_circle</v-icon>Delete
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-card-actions>
      </v-card>
    </v-hover>
    <delete-dialog :isOpen="deleteDialog" itemType="email" v-on:delete-item="deleteEmail"></delete-dialog>
  </v-flex>
</template>

<script>
import DeleteDialog from "@/components/shared/deleteDialog"

export default {
  name: "EmailCard",
  components: { DeleteDialog },
  props: ["email"],
  data() {
    return {
      deleteDialog: false,
      expandDetail: false
    }
  },
  methods: {
    deleteEmail(shouldDelete) {
      this.deleteDialog = false
      if (shouldDelete) {
        this.$emit('removeEmail', this.email)
      }
    }
  }
}
</script>
<style>
.case--avatar {
  position: absolute;
  top: 50%;
  left: 20px;
  margin-top: -21px;
}

.case--avatar.v-avatar {
  -webkit-box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.2),
    1px 1px 5px 0px rgba(0, 0, 0, 0.2), 1px 1px 5px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.2),
    1px 1px 5px 0px rgba(0, 0, 0, 0.2), 1px 1px 5px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  transform-style: preserve-3d;
}

.case--avatar:after {
  content: "";
  height: 27px;
  width: 54px;
  background: #e5e5e5;
  display: block;
  bottom: -7px;
  right: -7px;
  position: absolute;
  z-index: -1;
  border-radius: 0 0 27px 27px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.8);
  transform: translateZ(-1px);
}

.case--avatar:before {
  content: "";
  height: 27px;
  width: 54px;
  background: rgba(0, 0, 0, 0.1);
  display: block;
  top: -7px;
  left: -7px;
  position: absolute;
  z-index: -1;
  border-radius: 27px 27px 0 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  transform: translateZ(-1px);
}
</style>
